/* eslint-disable */
// @ts-nocheck

/* eslint-enable prettier/prettier */
/* eslint-enable @typescript-eslint/no-unused-vars */
/* eslint-enable import/no-unresolved */

import React from "react";
import type { ReactNode } from "react";
import {
  makeStyles,
  Paper,
  Box,
  Switch,
  FormControlLabel,
} from "@material-ui/core";
import { Stack } from "@mui/material";

export const useStyles = makeStyles({
  surveyTextTitle: {
    fontWeight: "700",
    margin: "0",
    padding: "2.0rem 0 0 1.0rem",
    overflowWrap: "anywhere",
    wordBreak: "break-word",
    hyphens: "auto",
    minWidth: 0,
  },
  content: {
    paddingLeft: "1.0rem",
    fontFamily: "Open Sans",
  },
  switchRoot: {
    "& .MuiSwitch-root": {
      height: "48px",
    },
  },
  switchFocus: {
    "& .MuiSwitch-switchBase": {
      height: "48px",
    },
    "& .Mui-checked.Mui-checked + .MuiSwitch-track": {
      border: "3px solid #92CF5C",
      borderRadius: "50px",
    },
    "& .MuiSwitch-track": {
      marginTop: "5px",
      height: "14px",
      border: "3px solid #999",
      borderRadius: "50px",
    },
    "& .MuiSwitch-colorSecondary.Mui-checked": {},
    "& .MuiSwitch-switchBase.Mui-focusVisible": {
      "& .MuiSwitch-thumb": {
        outline: "0.4rem solid #ff0000",
        outlineOffset: "0.4rem",
      },
    },
  },
});

type TProps = {
  head: ReactNode;
  body: ReactNode;
  smallMargin: boolean;
  showAccessibleViewSwitch?: boolean;
  toggleAccessibleView?: () => void;
  accessibleViewActive?: boolean;
  as?: "article";
  questionId?: string;
  textSize?: number;
};

function WidgetCard({
  head,
  body,
  smallMargin,
  showAccessibleViewSwitch = false,
  toggleAccessibleView = () => {},
  accessibleViewActive = false,
  as,
  questionId,
  textSize = 1.0,
}: TProps) {
  const classes = useStyles();
  const widgetId = questionId ? `widget-${questionId}` : "widget";

  // Base font size from master: 18px for survey questions
  const headingFontSize = 1.8 * textSize;
  const contentsFontSize = 1.4 * textSize;
  return (
    <Box
      style={{ margin: smallMargin ? "1em 0.2em" : "1em" }}
      component={as}
      aria-labelledby={widgetId}
    >
      <Paper elevation={3} style={{ padding: "1.0rem 2.0rem" }}>
        {head && (
          <>
            {showAccessibleViewSwitch ? (
              <Stack direction="row" gap={2} justifyContent={"space-between"}>
                <h3
                  id={widgetId}
                  className={classes.surveyTextTitle}
                  style={{ fontSize: `${headingFontSize}rem` }}
                >
                  {head}
                </h3>
                <FormControlLabel
                  className={classes.switchRoot}
                  control={
                    <Switch
                      className={classes.switchFocus}
                      onChange={toggleAccessibleView}
                      checked={accessibleViewActive}
                      disableRipple
                    />
                  }
                  label={
                    <label style={{ fontSize: "1.2rem" }}>
                      {I18n.t("surveys.accessible_view")}
                    </label>
                  }
                />
              </Stack>
            ) : (
              <h3
                id={widgetId}
                className={classes.surveyTextTitle}
                style={{ fontSize: `${headingFontSize}rem` }}
              >
                {head}
              </h3>
            )}
            <hr aria-hidden />
          </>
        )}
        <div
          className={classes.content}
          style={{ fontSize: `${contentsFontSize}rem` }}
        >
          {body}
        </div>
      </Paper>
    </Box>
  );
}

export default WidgetCard;
